"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Container = _interopRequireDefault(require("./Container"));

var _Aside = _interopRequireDefault(require("./Aside"));

var _TracksContent = _interopRequireDefault(require("./TracksContent"));

var _Track = _interopRequireDefault(require("./Track"));

var _model = require("./model");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var App = function App(_ref) {
  var bus = _ref.bus;
  var content = bus.getContent();
  var customTracks = content.customTracks,
      schedule = content.schedule,
      eventInfo = content.eventInfo,
      isAuth = content.isAuth,
      availableTracks = content.availableTracks,
      speakers = content.speakers;
  var discordLink = eventInfo.discordLink,
      chatLink = eventInfo.chatLink,
      chatLinkAuth = eventInfo.chatLinkAuth,
      startTime = eventInfo.conferenceStart,
      endTime = eventInfo.conferenceFinish;
  var timeTicks = (0, _model.createTimeTicks)(startTime, endTime);
  var calcPosition = (0, _model.calcPositionFromTime)(startTime);
  var trackWidth = calcPosition(endTime);

  var handleClick = function handleClick(eventContent) {
    var isTrackAvailable = true; // some conferences may provide availableTracks: Array<string>

    if (availableTracks) {
      isTrackAvailable = availableTracks.includes(eventContent.trackTitle);
    }

    var payload = {
      data: _objectSpread(_objectSpread({}, eventContent), {}, {
        /* TODO: switch to real date */
        date: eventContent.date || eventContent.track
      }),
      isAuth: isAuth,
      name: 'any-room',
      link: eventContent.speakerRoomLink || eventContent.discussionRoomLink || discordLink
    };

    if (eventContent.isQaEvent) {
      payload.isAuth = true;
      payload.link = isAuth ? chatLinkAuth : chatLink;
    }

    if (eventContent.speaker && isTrackAvailable && speakers) {
      var speakerData = speakers.main.find(function (s) {
        return s.name.trim().toLowerCase() === eventContent.speaker.trim().toLowerCase();
      });
      payload.name = 'speaker-card';
      payload.data = speakerData;
    } // TODO make type_id for events in db schema


    if (!eventContent.speakerRoomLink && !eventContent.discussionRoomLink && !eventContent.speaker && !discordLink) {
      payload.isAuth = true;
    }

    bus.clickEvent(payload);
  };

  return /*#__PURE__*/_react.default.createElement(_Container.default, null, /*#__PURE__*/_react.default.createElement(_Aside.default, {
    schedule: schedule,
    customTracks: customTracks
  }), /*#__PURE__*/_react.default.createElement(_TracksContent.default, {
    timeTicks: timeTicks,
    trackWidth: trackWidth,
    calcPosition: calcPosition
  }, schedule.map(function (sch, i) {
    return /*#__PURE__*/_react.default.createElement(_Track.default, {
      key: "".concat(sch.title, "-").concat(i),
      track: sch,
      calcPosition: calcPosition,
      onClick: handleClick
    });
  }), customTracks.map(function (tr, i) {
    return /*#__PURE__*/_react.default.createElement(_Track.default, {
      key: "".concat(tr.title, "-").concat(i),
      track: tr,
      calcPosition: calcPosition,
      onClick: handleClick
    });
  })));
};

var _default = App;
exports.default = _default;